import DefaultLayout from "@/layouts/DefaultLayout";
import KAccountSettings from "kinnect-front/KAccount/KAccountSettings";
import { Pageable } from "kinnect-mixins";

export default {
	name: "AccountSettingsPage",

	metaInfo: { title: "My Account - Settings" },

	mixins: [ Pageable ],

	render() {
		return <DefaultLayout maxWidth="600px">
			<KAccountSettings></KAccountSettings>
		</DefaultLayout>;
	}
};
